import { Component, OnInit, ViewChild } from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { InProductsService } from "../../../shared/services/inventory/in-products.service";
import { DataService } from '../../../shared/services/data.service';

export interface ImportItemModel {
  title: string;
}

@Component({
  selector: 'app-importitem',
  templateUrl: './importitem.component.html',
  styleUrls: ['./importitem.component.css']
})
export class ImportItemComponent extends DialogComponent<ImportItemModel, boolean> implements OnInit, ImportItemModel {
  title: string;
  result: any = { result: false, RtnItem: {} };
  ItemList: any = [];
  Columns: any;
  @ViewChild("dt") table: any;
  ImportItemList: any = [];

  constructor(dialogService: DialogService, private pds: InProductsService, private ds: DataService) {
    super(dialogService);
  }

  ngOnInit() {
    this.Columns = this.ShowColunms();
    this.getItem();
  }

  ShowColunms() {
    var List: any = [
      { field: 'Barcode', header: 'Barcode', t: 'text', f: 'input', w: "120px" },
      { field: 'ItemName', header: 'Item Name', t: 'text', f: 'input', w: "180px" },
      { field: 'Unit', header: 'Unit', t: 'text', f: 'input', w: "100px" },
      { field: 'Qty', header: 'Qty', t: 'decimal', f: 'input', w: "60px" },
      { field: 'CostPrice', header: 'Cost', t: 'decimal', f: 'decimal', w: "80px" },
      { field: 'SellingPrice', header: 'Selling Price', t: 'decimal', f: 'decimal', w: "80px" },
    ];
    return List;
  }

  onFilter(e) {

  }

  FilterColoum(dt, $event, field, mode, key = 'a') {

    if (key == 'e') {
      if ($event.keyCode == 13 && $event.which == 13) {
        dt.filter($event.target.value, field, mode)
      }
    } else if (field == "g") {
      if (key == 'e') {
        if ($event.keyCode == 13 && $event.which == 13) {
          dt.filterGlobal($event.target.value, 'contains')
        }
      } else {
        dt.filterGlobal($event.target.value, 'contains')
      }
    }
    else {
      dt.filter($event.target.value, field, mode)
    }
  }


  ok() {
    this.ImportItemList = [];
    if (this.ItemList.length != 0) {
      var importlist: any = []
      for (let i of this.ItemList) {
        importlist.push({
          Barcode: i.Barcode,
          Qty: i.Qty,
          Cost: i.CostPrice,
          Sellingprice: i.SellingPrice
        })
      }
      var IdItemType: any = {
        Id: this.ds.Settings.ItemTypeId,
        Barcode: "",
        SellingPrice: this.ds.Settings.SellingPriceLevelId,
        Branch: this.ds.Settings.BranchId,
        Location: this.ds.Settings.LocationId,
        excelitems: importlist
      }
      this.pds.ImportitemsfromExcel(IdItemType).subscribe(res => {
        if (res.Success) {
          for (let i of res.data) {
            this.ImportItemList.push(i)
            this.result.RtnItem = this.ImportItemList;
            this.result.result = true;
            this.close();
          }
        }
        else {
          alert(res.error.UserMsg);
          this.result.RtnItem = [];
          this.result.result = false;
          this.close();
        }
      });
    }
    else {
      alert("List Empty");
      this.result.RtnItem = [];
      this.result.result = false;
      this.close();
    }
  }

  getItem() {
    this.ItemList = [];
    this.ItemList.push({ Barcode: "112233", ItemName: "Detol", Unit: "PCS ( 1)", Qty: "10", CostPrice: "60", SellingPrice: "120" })
    this.ItemList.push({ Barcode: "3000157000011", ItemName: "Lyzol", Unit: "PCS ( 1)", Qty: "5", CostPrice: "50", SellingPrice: "90" })
    this.ItemList.push({ Barcode: "98755", ItemName: "Lyzol1", Unit: "PCS ( 1)", Qty: "5", CostPrice: "50", SellingPrice: "90" })
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/importitem/importitem.component.ts